export default __webpack_public_path__ + "static/media/hospitalBed.f4c4372a.svg";